"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx } from "react/jsx-runtime";
import React from "react";
import $ from "jquery";
import _ from "underscore";
import "../api/api";
import "select2";
import DOMPurify from "dompurify";
function formatContact(contact) {
  return {
    id: contact.email,
    text: contact.email,
    contact
  };
}
function itemTemplate(item) {
  if (item.contact) {
    let renderField2 = function(field) {
      return `<div title='${field.field}'>${field.value}</div>`;
    };
    var renderField = renderField2;
    const fieldsToShow = [
      { field: "Name", value: item.contact.name },
      { field: "Email", value: item.contact.email },
      { field: "Title", value: item.contact.title }
    ].filter((x) => x.value);
    const fields = fieldsToShow.map(renderField2).join("");
    return `<div style="display: flex; gap: 25px;">${fields}</div>`;
  }
  return item.text;
}
function formattedRecipients(props) {
  return _.map(props.recipients || [], (email) => ({ email }));
}
function localResults(props) {
  return [...formattedRecipients(props), ...contactsWithoutRecipients(props)];
}
function matchedLocalResults(props, term) {
  function matchesTerm(text) {
    return text && text.toLowerCase().includes(term.toLowerCase());
  }
  function itemMatchesTerm(item) {
    return !term || matchesTerm(item.email) || matchesTerm(item.title) || matchesTerm(item.name);
  }
  return localResults(props).filter(itemMatchesTerm);
}
function contactsWithoutRecipients(props) {
  return _.reject(props.contacts || [], (contact) => {
    return (props.recipients || []).indexOf(contact.email) >= 0;
  });
}
class EmailTypeAhead extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "recipientsRef", React.createRef());
    __publicField(this, "changed", () => {
      this.props.onChange(this.selectedEmails());
    });
    __publicField(this, "selectedEmails", () => this.$element().val() || []);
    __publicField(this, "$element", () => {
      var _a;
      return $((_a = this.recipientsRef.current) != null ? _a : []);
    });
    // Selects the email last, as if the user had typed it. The box reads recipients only at mount, so this is how a
    // caller adds one later.
    __publicField(this, "addRecipient", (email) => {
      const $element = this.$element();
      const selected = this.selectedEmails();
      if (selected.includes(email)) {
        return;
      }
      const $existing = $element.find("option").filter((_index, option) => option.value === email);
      const $option = $existing.length ? $existing : $("<option>", { value: email, text: email });
      $option.appendTo($element);
      $element.val([...selected, email]).trigger("change");
    });
    // Focuses the search field directly. select2("focus") does nothing until select2 sees the last blur, 1 ms later, so
    // it can miss a quick click.
    __publicField(this, "focus", () => {
      this.$element().next(".select2-container").find(".select2-search__field").trigger("focus");
    });
    __publicField(this, "loadSelect", () => {
      var _a, _b;
      const $element = this.$element();
      $element.select2({
        ajax: {
          url: "/api/contacts/search",
          dataType: "json",
          delay: 100,
          data: function(term) {
            return {
              query: term
            };
          },
          processResults: (data, params) => {
            params.page = params.page || 1;
            const localResults2 = matchedLocalResults(this.props, params.term);
            const remoteResults = params.term ? data.contacts : [];
            const results = [
              ..._.sortBy(localResults2, "email"),
              ..._.sortBy(remoteResults, "email")
            ].map(formatContact);
            return { results };
          },
          cache: true
        },
        escapeMarkup: (markup) => DOMPurify.sanitize(markup),
        templateResult: itemTemplate,
        tags: true,
        placeholder: "email addresses, comma or space separated"
      });
      if (this.props.selectByDefault) {
        _.each((_a = this.props.recipients) != null ? _a : [], (recipient) => {
          $element.append(
            $("<option>", {
              value: recipient,
              text: recipient
            })
          );
        });
        $element.val((_b = this.props.recipients) != null ? _b : "");
      }
      $element.on("change", this.changed);
      $element.trigger("change");
      $element.on("select2:unselect", this.changed);
      if (this.props.focusBehavior === "focus") {
        this.focus();
      }
    });
  }
  componentDidMount() {
    this.loadSelect();
  }
  // Undoes loadSelect, so remounting (StrictMode does this in development)
  // doesn't append the default recipients and bind the handlers twice.
  componentWillUnmount() {
    const $element = this.$element();
    $element.off("change", this.changed);
    $element.off("select2:unselect", this.changed);
    $element.select2("destroy");
    $element.empty();
  }
  render() {
    return /* @__PURE__ */ jsx(
      "select",
      {
        "data-component": "EmailTypeAhead",
        ref: this.recipientsRef,
        multiple: true,
        style: { display: "none" }
      }
    );
  }
}
export default EmailTypeAhead;
